jQuery_T4NT(document).ready(function($) {

  /**
  *  Variant selection changed
  *  data-variant-toggle="{{variant.id}}"
  */
  $( document ).on( "variant:changed", function( evt ) {
   console.log( evt.currentVariant );
   // $('[data-variant-toggle]').hide(0);
   // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

});

$(".t4s-product-form__buttons button").on("click", function () {
    if ($("input[type='radio'][value='subscription']:checked").length) {
        $("body").addClass("subscription_in_cart");
    }
});

// Function to check for subscription in the cart when it's visible
function checkSubscriptionInCart() {
    const miniCart = $("#t4s-mini_cart");
    
    if (miniCart.attr("aria-hidden") === "false") { // Check if cart is now visible
        if (miniCart.find(".t4s-cart_selling_plan").length) {
            $("body").addClass("subscription_in_cart");
        } else {
            $("body").removeClass("subscription_in_cart");
        }
    }
}

// Observe changes in #t4s-mini_cart's aria-hidden attribute
function observeMiniCart() {
    let miniCart = document.querySelector("#t4s-mini_cart");

    if (!miniCart) return; // Exit if cart element is not found

    let observer = new MutationObserver(() => {
        checkSubscriptionInCart();
    });

    observer.observe(miniCart, { attributes: true, attributeFilter: ["aria-hidden"] });
}

// Start observing when the cart button is clicked
$(document).on("click", ".t4s-site-nav__cart", function () {
    observeMiniCart();
    setTimeout(checkSubscriptionInCart, 500); // Ensure it runs initially in case of quick load
});
 
// GROWING REVIEWS SLIDER -- START
jQuery(document).ready(function($) {
  $('.glowing_review_slider').slick({
    dots: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 5C8 5.742 7.267 6.85 6.525 7.78C5.571 8.98 4.431 10.027 3.124 10.826C2.144 11.425 0.956 12 0 12M0 12C0.956 12 2.145 12.575 3.124 13.174C4.431 13.974 5.571 15.021 6.525 16.219C7.267 17.15 8 18.26 8 19M0 12H24" stroke="#535251"/></path></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 5C16 5.742 16.733 6.85 17.475 7.78C18.429 8.98 19.569 10.027 20.876 10.826C21.856 11.425 23.044 12 24 12M24 12C23.044 12 21.855 12.575 20.876 13.174C19.569 13.974 18.429 15.021 17.475 16.219C16.733 17.15 16 18.26 16 19M24 12H0" stroke="#535251"/></path></svg></button>',
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          infinite: false,
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
// GROWING REVIEWS SLIDER -- END

// PEFECT ROUTINE SLIDER -- STRAT
jQuery(document).ready(function($) {
  $('.perfect_routine_grid').slick({
    dots: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 5C8 5.742 7.267 6.85 6.525 7.78C5.571 8.98 4.431 10.027 3.124 10.826C2.144 11.425 0.956 12 0 12M0 12C0.956 12 2.145 12.575 3.124 13.174C4.431 13.974 5.571 15.021 6.525 16.219C7.267 17.15 8 18.26 8 19M0 12H24" stroke="#535251"/></path></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 5C16 5.742 16.733 6.85 17.475 7.78C18.429 8.98 19.569 10.027 20.876 10.826C21.856 11.425 23.044 12 24 12M24 12C23.044 12 21.855 12.575 20.876 13.174C19.569 13.974 18.429 15.021 17.475 16.219C16.733 17.15 16 18.26 16 19M24 12H0" stroke="#535251"/></path></svg></button>',
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          infinite: false,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          // variableWidth: true
        }
      }
    ]
  });
});

// PEFECT ROUTINE SLIDER -- END


// FAQs -- START
jQuery(document).ready(function () {
  jQuery(".harmonize-set > a").on("click", function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this).siblings(".harmonize-content").slideUp(200);
      jQuery(".harmonize-set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".harmonize-set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      jQuery(".harmonize-set > a").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".harmonize-content").slideUp(200);
      jQuery(this).siblings(".harmonize-content").slideDown(200);
    }
  });
});

// FAQs -- END

// INSTAGRAM SLIDER -- START
jQuery(document).ready(function () {
  jQuery(".Instagram-slider").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
// INSTAGRAM SLIDER -- START

// PRODUCT ACCORDION -- START
document.addEventListener("DOMContentLoaded", function () {
  const accordionItemHeaders = document.querySelectorAll(
    ".panel_accordion_header"
  );

  // If no headers exist, exit early
  if (accordionItemHeaders.length === 0) return;

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".panel_accordion_header.active"
      );

      // Close the currently active accordion if it is not the clicked one
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.remove("active");
        const activeBody = currentlyActiveAccordionItemHeader.nextElementSibling;
        if (activeBody) activeBody.style.maxHeight = 0;
      }

      // Toggle the clicked accordion
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemBody) {
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      }
    });
  });
});

// PRODUCT ACCORDION -- END

// PRODUCT USPS MARQUEE -- START
$('.usps_marquee_slider').slick({
  slidesToShow: 9,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: true,
  variableWidth: true,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear'
  
  /*,
  responsive: [
    {
      breakpoint: 1299,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]*/
});
// PRODUCT USPS MARQUEE -- END

// CART PROGRESS
setInterval(function(){
  let goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
   let goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
   let goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
   let goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
 if(jQuery('#t4s-mini_cart').attr('aria-hidden') == "false"){
   
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      console.log("totalCart",totalCart);
      jQuery('.empty__cart').hide();
      jQuery('.cc-cart-progress').show();
      jQuery('.t4s-drawer__bottom').show();
      jQuery('.payments-image').show();
      if(totalCart > 0){
        jQuery('.cart_checkout_btn').show();
        jQuery('.cart_checkout_btn button').show();
        console.log("innnn->")
        var chkBundle = '';
        var normalProCounter = 0;
        cart.items.forEach(function(item) {
          var str1 = item.title;
          var str2 = 'Bundle';
          var str3 = 'Free Returns';
          if(str1.indexOf(str2) != -1){
            chkBundle = '1';
          }
          else{
            if(str1.indexOf(str3) != -1){

            }
            else{
              normalProCounter = eval(normalProCounter) + eval(item.quantity);
            }
          }
        });

        if(chkBundle == '1' || normalProCounter > 1){
          jQuery('.cart_bundle_product').hide();
        }
        else{
          jQuery('.cart_bundle_product').show();
        }
        
        subTotal = cart.total_price;
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
      
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }else{
          jQuery('.cart_shipping_box').hide();
        }
        
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="common-svg"><path d="M4.26263 14.337C3.71663 14.337 3.25388 14.1463 2.87438 13.7648C2.49438 13.3833 2.30437 12.92 2.30437 12.375H1.26562V4.962C1.26562 4.6165 1.38137 4.32825 1.61287 4.09725C1.84438 3.86625 2.13263 3.7505 2.47763 3.75H12.4001V6.462H14.1311L16.7276 9.95175V12.375H15.5156C15.5156 12.92 15.3246 13.3833 14.9426 13.7648C14.5606 14.1463 14.0966 14.3368 13.5506 14.3363C13.0046 14.3358 12.5421 14.1453 12.1631 13.7648C11.7841 13.3843 11.5941 12.921 11.5931 12.375H6.22688C6.22688 12.923 6.03588 13.387 5.65388 13.767C5.27188 14.147 4.80788 14.337 4.26188 14.337M4.26488 13.587C4.60238 13.587 4.88863 13.4695 5.12363 13.2345C5.35863 12.9995 5.47613 12.713 5.47613 12.375C5.47613 12.037 5.35863 11.7508 5.12363 11.5163C4.88863 11.2818 4.60238 11.1643 4.26488 11.1638C3.92738 11.1633 3.64113 11.2808 3.40613 11.5163C3.17113 11.7517 3.05363 12.038 3.05363 12.375C3.05363 12.712 3.17113 12.9983 3.40613 13.2338C3.64113 13.4693 3.92738 13.5875 4.26488 13.587ZM2.01487 11.625H2.50013C2.60663 11.294 2.82388 11.0095 3.15188 10.7715C3.47988 10.5335 3.85088 10.414 4.26488 10.413C4.65988 10.413 5.02638 10.53 5.36438 10.764C5.70188 10.9975 5.92388 11.2845 6.03038 11.625H11.6501V4.5H2.47688C2.36137 4.5 2.25563 4.548 2.15963 4.644C2.06313 4.74 2.01487 4.84575 2.01487 4.96125V11.625ZM13.5536 13.587C13.8911 13.587 14.1774 13.4695 14.4124 13.2345C14.6474 12.999 14.7649 12.7125 14.7649 12.375C14.7649 12.0375 14.6474 11.7513 14.4124 11.5163C14.1774 11.2813 13.8911 11.1638 13.5536 11.1638C13.2161 11.1638 12.9299 11.2813 12.6949 11.5163C12.4599 11.7513 12.3424 12.0375 12.3424 12.375C12.3424 12.7125 12.4599 12.9988 12.6949 13.2338C12.9299 13.4688 13.2161 13.587 13.5536 13.587ZM12.4001 10.125H15.9341L13.7276 7.212H12.4001V10.125Z" fill="#535251"></path></svg>';
        if(percentage_reached == 100){
          tempStr += goalReachText;
            svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
        }
        else{
          if(goalAmount > cartTotalFull){
            var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
            tempStr += goalBeforeText;
            tempStr += ' <span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
            tempStr += Shopify.formatMoney(goalPendingAmount);
            tempStr += '</span> '
            tempStr += goalAfterText;
          }
        }
        if(tempStr != ''){
          jQuery('.cart__goal__message').html(tempStr);
          jQuery('.cc-cart-progress-heading .svg-html').html('');
          jQuery('.cc-cart-progress-heading .svg-html').html(svg);
        }
      }
      else{
        jQuery('.empty__cart').show();
        jQuery('.cc-cart-progress').hide();
        jQuery('.t4s-drawer__bottom').hide();
        jQuery('.payments-image').hide();
        jQuery('.cart_checkout_btn').hide();
        jQuery('.cart_bundle_product').hide();
      }
  });
 }
},100);
// END :: CART PROGRESS

$(document).ready(function () {
  //bundle cart js 
  $(document).on("click", ".cb_btn_link__bundle", function (e) {
    var vid = $(this).attr('data-vid');

    jQuery.getJSON('/cart.js', function(cart) {
      cart.items.forEach(function(item) {
        updateCart(0,item.key)
      });
    });
    setTimeout(function() {
      addItemCart(vid);
    }, 1000);
    e.preventDefault();
    // your code here
    return false;
  });
  
  // Handle the increase button click
  $(document).on("click", "[data-increase-qty-new]", function () {
    var lineKey = $(this).attr("data-linekey");
    var $wrapper = $(this).closest(".t4s-quantity-wrapper");
    var $input = $wrapper.find(".t4s-quantity-input");
    var currentValue = parseInt($input.val(), 10) || 0; // Ensure numeric value
    var max = parseInt($input.attr("max"), 10) || Infinity; // Get max value if specified

    if (currentValue < max) {
      var newVal = currentValue + 1;
      $input.val(newVal); // Increase value
      if(newVal >= 1){
        $(this).parent().find('[data-decrease-qty-new]').find('.minus__svg').show();
        $(this).parent().find('[data-decrease-qty-new]').find('.trash__remove').hide();
      }
      else{
        $(this).parent().find('[data-decrease-qty-new]').find('.minus__svg').hide();
        $(this).parent().find('[data-decrease-qty-new]').find('.trash__remove').show();
      }
      updateCart(newVal, lineKey);
    }
  });

  // Handle the decrease button click
  $(document).on("click", "[data-decrease-qty-new]", function () {
    var lineKey = $(this).attr("data-linekey");
    var $wrapper = $(this).closest(".t4s-quantity-wrapper");
    var $input = $wrapper.find(".t4s-quantity-input");
    var currentValue = parseInt($input.val(), 10) || 0; // Ensure numeric value
    var min = parseInt($input.attr("min"), 10) || 0; // Get min value if specified

    if (currentValue > min) {
      var newVal = currentValue - 1;
      $input.val(newVal); // Decrease value
      if(newVal == 1){
        $(this).find('.minus__svg').hide();
        $(this).find('.trash__remove').show();
      }
      else{
        $(this).find('.minus__svg').show();
        $(this).find('.trash__remove').hide();
      }
      updateCart(newVal, lineKey);
    }
  });
});

function addItemCart(variantId){
  $('.t4s-drawer__wrap').addClass('is-loading');
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: 1,
        id: variantId
    },
    success: function(cart) {
      $('.t4s-drawer__wrap').removeClass('is-loading');
       refreshCartNew();
    },
    error: function(response) {
      $('.t4s-drawer__wrap').removeClass('is-loading');
        //alert(response);
    }
  });  
}

function updateCart(Quantity,lineKey){
  $('.t4s-drawer__wrap').addClass('is-loading');
   $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: lineKey
    },
    success: function(cart) {
      $('.t4s-drawer__wrap').removeClass('is-loading');
       refreshCartNew();
    },
    error: function(response) {
      $('.t4s-drawer__wrap').removeClass('is-loading');
        //alert(response);
    }
  });  
}

function refreshCartNew(){
  var url = '/cart?sections=ajax-cart-item';
  jQuery.ajax({
    url: url,
    type: 'GET',
    success: function(response) {
      var newContentHTML = response['ajax-cart-item'];
      jQuery('.t4s-mini_cart__items').html(newContentHTML);
    }
  });
}


$(document).ready(function () {
  const timerKey = "countdown4HourTimer"; // Key for localStorage
  let endTime;

  function get4HoursFromNow(endTimeHr='') {
    if(endTimeHr){
      return Date.now() + eval(endTimeHr) * 60 * 60 * 1000; // Current time + 4 hours in milliseconds
    }
    else{
      return Date.now() + 4 * 60 * 60 * 1000; // Current time + 4 hours in milliseconds
    }
  }

  // Initialize or retrieve the end time
  if (localStorage.getItem(timerKey)) {
    endTime = parseInt(localStorage.getItem(timerKey), 10);

    // If the end time has passed, reset it to a new 4-hour timer
    if (Date.now() > endTime) {
      endTime = get4HoursFromNow();
      localStorage.setItem(timerKey, endTime);
    }
  } else {
    // If no timer exists, start a new 4-hour timer
    endTime = get4HoursFromNow();
    localStorage.setItem(timerKey, endTime);
  }

  function updateTimer(endTimeHr) {
    const now = Date.now();
    const remainingTime = Math.floor((endTime - now) / 1000); // Remaining time in seconds

    if (remainingTime > 0) {
      // Calculate hours, minutes, and seconds
      const hours = Math.floor(remainingTime / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((remainingTime % 3600) / 60)
        .toString()
        .padStart(2, '0');
      const seconds = (remainingTime % 60).toString().padStart(2, '0');

      // Update the timer display
      $('#timer #hours').text(hours);
      $('#timer #minutes').text(minutes);
      $('#timer #seconds').text(seconds);
    } else {
      // Timer has reached 0, restart the timer
      endTime = get4HoursFromNow(endTimeHr);
      localStorage.setItem(timerKey, endTime);
    }
  }

  // Update the timer every second
  const timerInterval = setInterval(updateTimer, 1000);

  // Initialize the timer display
  if($('.t4s-product-giftbox').length > 0){
    var endTimeHr = $('.t4s-product-giftbox').attr('data-limit');
    updateTimer(endTimeHr);
  }
});

$(document).on("kepress keyup", "[data-frm-search]", function () {
  if($(this).hasClass('has--search-terms')){
    
  }
  else{
    $(this).addClass('has--search-terms');
  }
});

$(document).on("click", "[data-drawer-close]", function () {
  $('[data-input-search]').val('');
  $('[data-frm-search]').removeClass('has--search-terms');
  $('.t4s-skeleton_wrap').show();
});

// BUNDLE SELECTOR -- START

$(document).ready(function () {
  if(jQuery('.variant__bundle_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').length > 0){
    jQuery('.variant__bundle_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').eq(1).addClass('active');
    jQuery('.variant__bundle_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').eq(1).trigger('click');
  }

  if(jQuery('.bundle_selector_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').length > 0){
    jQuery('.bundle_selector_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').eq(1).addClass('active');
    setTimeout(function(){
      jQuery('.bundle_selector_box').find('.bundle_selector_grid').find('.bundle_selector_col.double_bundle_col').trigger('click');
    }, 1000);
  }
  
  if($('.variant__bundle_box').find('.bundle_selector_grid').find('.bundle_selector_col').length > 0){
    var qty = $('.bundle_selector_col.active').attr('data-qty');
    var getvariant = $('.bundle_selector_col.active').attr('data-variant');
    setTimeout(function(){
      jQuery('.t4s-swatch__list').find('.t4s-swatch__item').removeClass("is--selected");
      jQuery('.t4s-form__product').find('.t4s-product__select').removeAttr("selected");
      jQuery('.t4s-form__product').find('.t4s-product__select option[data-variant="'+getvariant+'"]').prop("selected",true);
      jQuery('.t4s-swatch__list').find('.t4s-swatch__item[data-value="'+getvariant+'"]').addClass("is--selected");
      //jQuery('.t4s-swatch__list').find('.t4s-swatch__item[data-value="'+getvariant+'"]').trigger("click");
    },1000);
    $('[name="quantity"]').val(qty);
    var objhtml =  $('.bundle_selector_col.active');
    variantChangeSet(objhtml,getvariant)
  }
  $(".bundle_selector_col").on("click", function () {
      $(".bundle_selector_col").removeClass("active");
      var qty = $(this).attr('data-qty');
      var getvariant = $(this).attr('data-variant');
      var objhtml = $(this);
      // Update quantity field
      $('[name="quantity"]').val(qty);
      // Add active class to clicked column
      $(this).addClass("active");
      variantChangeSet(objhtml,getvariant)
  });
});

//function price set and variant select for change variant
function variantChangeSet(objhtml,getvariant){
  // Reset swatches and select options
    jQuery('.t4s-swatch__list').find('.t4s-swatch__item').removeClass("is--selected");
    jQuery('.t4s-form__product').find('.t4s-product__select').prop("selected", false);
    jQuery('.t4s-form__product').find('.t4s-product__select option[data-variant="'+getvariant+'"]').prop("selected", true);

    // Set selected swatch item
    jQuery('.t4s-swatch__list').find('.t4s-swatch__item[data-value="'+getvariant+'"]').addClass("is--selected");

    // Get selected variant ID
    var getVariantId = jQuery('.t4s-form__product').find('.t4s-product__select option:selected').val();

    // Update the URL and payment terms with the variant ID
    //replaceUrlBrowser(getVariantId);
    var comparePrice = objhtml.find(".bundle_selector_pricebox .bundle_compare_price").attr("data-cprice");
    var mainPrice = objhtml.find(".bundle_selector_pricebox .bundle_sale_price").attr("data-price");
  
    var orgcomparePrice = comparePrice;
    var orgmainPrice = mainPrice;
    comparePrice = (comparePrice/100);
    mainPrice = (mainPrice/100);
    jQuery('shopify-payment-terms').attr("variant-id", getVariantId);
    var savingOff = calculateDiscountPercentage(comparePrice,mainPrice);
    jQuery('.t4s-product__price-review').find('.t4s-product-price del').text(Shopify.formatMoney(orgcomparePrice));
    jQuery('.t4s-product__price-review').find('.t4s-product-price ins').text(Shopify.formatMoney(orgmainPrice));
    jQuery('.t4s-product__price-review').find('.t4s-badge-price').text('SAVE '+savingOff+'%');

    //radio set price
    var textGet = jQuery('.rc-template__radio').find('.subscription-radio .rc-radio__subscription').text();
    var percentOff  = textGet.replace(/[^0-9]/g, '');
    if(percentOff=="" || percentOff==undefined){
      percentOff=10;
    }
    percentOff = parseInt(percentOff);
    var discountPrice = calculateDiscountedPrice(mainPrice,percentOff);
    jQuery('.rc-template__radio').find('.onetime-radio span').text("One-time purchase "+Shopify.formatMoney(orgmainPrice));
    jQuery('.rc-template__radio').find('.subscription-radio .rc-radio__price').text(Shopify.formatMoney(discountPrice));
}

// Function to calculate the discounted price
function calculateDiscountedPrice(originalPrice, discountPercentage) {
    var discountAmount = (originalPrice * discountPercentage) / 100; // Calculate the discount amount
    var discountedPrice = originalPrice - discountAmount; // Subtract the discount amount from the original price
    return discountedPrice.toFixed(2); // Return the discounted price rounded to 2 decimal places
}

function calculateDiscountPercentage(originalPrice, discountedPrice) {
    var discount = ((originalPrice - discountedPrice) / originalPrice) * 100;
    return Math.round(discount); // Return the discount percentage rounded to 2 decimal places
}

function replaceUrlBrowser(variantid){
  var currentUrl = window.location.href;
  var url = new URL(currentUrl);
  url.searchParams.set('variant',variantid);
  history.pushState(null, null, url.toString());
}
// BUNDLE SELECTOR -- END

// PERFECT ROUTINE -- START

$(document).ready(function(){
  $('.pr_header_labels .prh_label_box').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('.pr_header_labels .prh_label_box').removeClass('current');
      $('.perfect_routine_grid').removeClass('current');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
      $('.perfect_routine_grid').slick('refresh');
  })
})

// PERFECT ROUTINE -- END
